import { useMemo } from 'react';
import { validateSearch, SearchValidation } from 'functions';
import { useAccountId } from 'state';

export default function useSearchValidation(query: string): SearchValidation {
    const accountId = useAccountId();

    return useMemo(
        () => validateSearch(query, accountId),
        [query, accountId]
    );
}
